export default __webpack_public_path__ + "static/media/591.a16945d2.png";